/* eslint-disable max-classes-per-file */
/* eslint-disable camelcase */
import { loginService, APIBase } from '@agro1desenvolvimento/apis-js-package';
import { ENV } from '../../utilities/constants';

class LaboratorioAPI extends APIBase {
  constructor() {
    super();

    let baseURL = 'https://homologacao-integrations.aqila.com.br';
    if (ENV === 'production') {
      baseURL = 'https://integrations.aqila.com.br';
    }

    this.initialize({ baseURL });

    this.request.interceptors.request.use((request) => {
      const headers = loginService.requestHeaders();
      delete headers['X-Scope'];
      request.headers = {
        ...headers,
        ...request.headers,
        'X-Scope': 'sementes',
      };
      return request;
    });
  }
}

const laboratorioAPI = new LaboratorioAPI();

interface APICidade {
  nome: string;
  uf: string;
  ibge: string;
}

interface APIProdutor {
  id: string;
  nome: string;
  nome_fantasia?: string;
  tipo: string;
  cpf_cnpj: string;
  inscricao_estadual?: string;
  inscricao_municipal?: string;
  telefone?: string;
  email?: string;
  endereco?: string;
  endereco_numero?: string;
  endereco_complemento?: string;
  endereco_bairro?: string;
  endereco_cep?: string;
  cidade?: APICidade;
  integration_status: number;
  updated_at: string;
}

interface APIListResponse {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
  data: APIProdutor[];
}

export interface ProdutorLaboratorio {
  id: string;
  nome: string;
  nomeComCidade: string;
}

function convertAPIToInternal(apiData: APIProdutor): ProdutorLaboratorio {
  const cidade = apiData.cidade
    ? `${apiData.cidade.nome} - ${apiData.cidade.uf}`
    : '';

  return {
    id: apiData.id,
    nome: apiData.nome,
    nomeComCidade: cidade ? `${apiData.nome} (${cidade})` : apiData.nome,
  };
}

class ProdutoresService {
  async list(
    params: Record<string, any> = {},
  ): Promise<{ data: ProdutorLaboratorio[], headers: any }> {
    const response = await laboratorioAPI.get<APIListResponse>(
      '/api/v1/agro1/laboratorio/produtores_laboratorios',
      { params },
    );

    const data = response.data.data.map(convertAPIToInternal);

    return {
      data,
      headers: response.headers,
    };
  }

  async getById(id: string): Promise<ProdutorLaboratorio | null> {
    const response = await laboratorioAPI.get<APIListResponse>(
      '/api/v1/agro1/laboratorio/produtores_laboratorios',
      { params: { id } },
    );

    if (!response.data.data || response.data.data.length === 0) {
      return null;
    }

    return convertAPIToInternal(response.data.data[0]);
  }
}

export default new ProdutoresService();
